import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconGold: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"gold, goldbars"} maskId="square-filled-radius-0-stroke-1-IconGold"><path d="M11.7109 18H1.28906L3.44824 12H9.55176L11.7109 18Z" fill="currentColor"/><path d="M22.7109 18H12.2891L14.4482 12H20.5518L22.7109 18Z" fill="currentColor"/><path d="M17.2109 11H6.78906L8.94824 5H15.0518L17.2109 11Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconGold;
